import { StreamPriorityOptions } from "http2";
import React, { useEffect, useState } from "react";
import { Row, Col, Modal, FloatingLabel, Button, Form } from "react-bootstrap";
import MyUploader from "../Dropzone/dropzone";
import CenterService from "../../services/center.service";
import { toast } from "react-toastify";
import Select from "react-select";
import { WorkerCategoryEnum } from "../../enum/WorkerCategory.enum";
import { useParams } from "react-router-dom";
import { AdminService } from "../../services/admin.service";
import { UploadService } from "../../services/upload.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEye, faPlus } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { employeeValidation } from "../../validations/employee.validation";
import PreviewModal from "./Preview.modal";
import moment from "moment";
import { ObjectHelper } from "../../helpers/object.helper";

interface IAddEmployeeModal {
  show: boolean;
  handleClose: any;
  corpId: string;
  reload: any
}

export default function AddEmployeeModal(props: IAddEmployeeModal) {
  const params: any = useParams();

  const [employee, setEmployee] = useState<any>({});
  const [selectedCategory, setSelectedCategory] = useState<any>({});
  const [employeeType, setEmployeeType] = useState<any>();
  const [showPreviewModal, setShowPreviewModal] = useState<any>(undefined);

  const onValueChange = (e: any) => {
    setEmployee({ ...employee, [e.target.name]: e.target.value });
  };

  const getEmployeeType = async () => {
    await CenterService.getEmployeeType().then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        setEmployeeType(res.data.enums.map((data: any) => {
          return {
            label: data,
            value: data
          }
        }));
      }
    })
  }

  useEffect(() => {
    getEmployeeType();
  }, [])

  const addEmployee = async () => {
    const data = {
      idCard: employee.idCard ? employee.idCard[0] : undefined,
      employeeName: employee.employeeName,
      workerCategory: selectedCategory.value,
      typeOfEmployee: employee.typeOfEmployee,
      gender: employee.gender,
      email: employee.email,
      address: employee.address,
      dob: moment(employee.dob).toISOString(),
      image: employee.image ? employee.image[0] : undefined,
      phoneNumber: employee.phoneNumber,
      aadhar: employee.aadhar,
      fatherName: employee.fatherName,
      motherName: employee.motherName,
      aadhar_front: employee.aadhar_front ? employee.aadhar_front[0] : undefined,
      aadhar_back: employee.aadhar_back ? employee.aadhar_back[0] : undefined,
      pan: employee?.pan ? employee?.pan[0] : undefined,
    };
    const validateData = employeeValidation.validate(ObjectHelper.removeEmpty(data));
    if (validateData.error) {
      toast.error("Error: " + validateData.error);
      return false;
    }
    await CenterService.createCenterEmployee(data, params.centerId)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Employee Registered");
          props.handleClose();
          props.reload();
        }
      })
      .catch((error) => {
        console.error(error.response.data);
        toast.error("Something went wrong " + error.response.status);
      });
  };

  const fileSelectedHandler = async (e: any, name: string) => {
    const fd = new FormData();
    // let arr=[];
    for (let i of e) {
      fd.append("upload", i);
    }
    await UploadService.uploadFileToS3(fd).then((res: any) => {
      if (res.status === 200) {
        setEmployee({ ...employee, [name]: res.data });
        toast.success(`File(s) uploaded`);
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const genderData = [
    {
      label: "Male",
      value: "male"
    },
    {
      label: "Female",
      value: "female"
    },
    {
      label: "Other",
      value: "other"
    },
  ]

  return (
    <>
      <PreviewModal
        show={showPreviewModal}
        setShow={setShowPreviewModal}
      />


      <Modal
        show={props.show}
        onHide={props.handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Employee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="fw-bold text-primary">Personal Info</h6>

          <Row>
            <Col md="12">
              <FloatingLabel
                controlId="floatingInput"
                label="Name"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  name="employeeName"
                  onChange={(e) => onValueChange(e)}
                />
              </FloatingLabel>
              <FloatingLabel
                controlId="floatingInput"
                label="Phone Number"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  onChange={(e) => onValueChange(e)}
                  required
                />
              </FloatingLabel>
              <FloatingLabel
                controlId="floatingInput"
                label="Email"
                className="mb-3"
              >
                <Form.Control
                  type="email"
                  name="email"
                  onChange={(e) => onValueChange(e)}
                />
              </FloatingLabel>
              <FloatingLabel
                controlId="floatingInput"
                label="Address"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  name="address"
                  onChange={(e) => onValueChange(e)}
                />
              </FloatingLabel>
              <FloatingLabel
                controlId="floatingInput"
                label="Aadhar"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  name="aadhar"
                  onChange={(e) => onValueChange(e)}
                />
              </FloatingLabel>
              <FloatingLabel
                controlId="floatingInput"
                label="Father Name"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  name="fatherName"
                  onChange={(e) => onValueChange(e)}
                />
              </FloatingLabel>
              <FloatingLabel
                controlId="floatingInput"
                label="Mother Name"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  name="motherName"
                  onChange={(e) => onValueChange(e)}
                />
              </FloatingLabel>
              <Form.Label className="text-muted xcn-text-10">
                Gender
              </Form.Label>
              <Select
                options={genderData}
                placeholder="Category"
                className="mb-3"
                onChange={(e: any) => setEmployee({ ...employee, gender: e.value })}
              />

              <hr className="mx-3 mt-5" />
              <h6 className="fw-bold text-primary">Other Info</h6>
              <Form.Label className="text-muted xcn-text-10">DOB</Form.Label>
              <DatePicker
                selected={employee.dob}
                name="dob"
                className="form-control"
                onChange={(e: Date) => setEmployee({ ...employee, dob: e })}
              />

              {/* <Form.Label className="text-muted xcn-text-10">
                Employee Type
              </Form.Label>
              <Select
                options={employeeType}
                placeholder="Category"
                className="mb-3"
                onChange={(e) => setEmployee({ ...employee, typeOfEmployee: e })}
              /> */}


              <Form.Label className="text-muted xcn-text-10">
                Worker Category
              </Form.Label>
              <Select
                options={Object.values(WorkerCategoryEnum).map(
                  (category: any) => {
                    return {
                      value: category,
                      label: category.split("_").join(" ").toUpperCase(),
                    };
                  }
                )}
                placeholder="Category"
                className="mb-3"
                onChange={(e) => {
                  setSelectedCategory(e);
                }}
              />

              <Form.Label className="text-muted xcn-text-10">
                Type of Employee
              </Form.Label>
              <Select
                options={employeeType}
                placeholder="Category"
                className="mb-3"
                onChange={(e: any) => setEmployee({ ...employee, typeOfEmployee: e.value })}
              />
              <div className="d-flex justify-content-between align-items-center mx-5">
                <div className="mt-4 text-secondary fw-bold w-100">
                  <h6>
                    User Image{" "}
                    {employee.image && (
                      <>
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-success"
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary ms-2"
                          onClick={() => setShowPreviewModal(employee.image)}
                        />
                      </>
                    )}{" "}
                  </h6>
                  <MyUploader
                    fileSelectedHandler={(e: any) =>
                      fileSelectedHandler(e, "image")
                    }
                  />
                </div>

                <div className="mt-4 text-secondary fw-bold mt-4 w-100 mx-5">
                  <h6>
                    Id Card{" "}
                    {employee.idCard && (
                      <>
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-success"
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary ms-2"
                          onClick={() => setShowPreviewModal(employee.idCard)}
                        />
                      </>
                    )}
                  </h6>
                  <MyUploader
                    fileSelectedHandler={(e: any) =>
                      fileSelectedHandler(e, "idCard")
                    }
                  />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mx-5">
                <div className="mt-4 text-secondary fw-bold w-100">
                  <h6>
                    Aadhar Front{" "}
                    {employee.aadhar_front && (
                      <>
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-success"
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary ms-2"
                          onClick={() => setShowPreviewModal(employee.aadhar_front)}
                        />
                      </>
                    )}{" "}
                  </h6>
                  <MyUploader
                    fileSelectedHandler={(e: any) =>
                      fileSelectedHandler(e, "aadhar_front")
                    }
                  />
                </div>

                <div className="mt-4 text-secondary fw-bold mt-4 w-100 mx-5">
                  <h6>
                    Aadhar Back{" "}
                    {employee.aadhar_back && (
                      <>
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-success"
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary ms-2"
                          onClick={() => setShowPreviewModal(employee.aadhar_back)}
                        />
                      </>
                    )}
                  </h6>
                  <MyUploader
                    fileSelectedHandler={(e: any) =>
                      fileSelectedHandler(e, "aadhar_back")
                    }
                  />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mx-5">
                <div className="mt-4 text-secondary fw-bold w-100">
                  <h6>
                    Pan Card{" "}
                    {employee.pan && (
                      <>
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-success"
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary ms-2"
                          onClick={() => setShowPreviewModal(employee.pan)}
                        />
                      </>
                    )}{" "}
                  </h6>
                  <MyUploader
                    fileSelectedHandler={(e: any) =>
                      fileSelectedHandler(e, "pan")
                    }
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Button
            className="mt-5 fw-bold"
            size="sm"
            onClick={() => addEmployee()}
          >
            Add Employee <FontAwesomeIcon icon={faPlus} />
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
